import { useState } from "react";
import { Report } from "../ReportComponent";
import { ReportPreviewModal, type ReportData } from "../ReportPreview";
import { Geometry } from "../../services/api";

interface ReportModalProps {
  isOpen: boolean;
  onClose: () => void;
  showModal?: boolean;
  selectedDrawingId?: string | null;
  selectedCityGeometry?: Geometry | null;
  selectedCityName?: string | null;
  systemMode?: "sin" | "distribuidora";
  onSelectAreaMarking?: (drawingId: string) => void;
  onSelectCityMarking?: () => void;
  onDeselectMarking?: () => void;
}

export function ReportModal({
  isOpen,
  selectedDrawingId,
  selectedCityGeometry,
  selectedCityName,
  systemMode,
  onSelectAreaMarking,
  onSelectCityMarking,
  onDeselectMarking,
}: ReportModalProps) {
  const [previewData, setPreviewData] = useState<ReportData | null>(null);
  const [isPreviewOpen, setIsPreviewOpen] = useState(false);

  const handlePreviewReady = (reportData: ReportData) => {
    setPreviewData(reportData);
    setIsPreviewOpen(true);
  };

  const handleClosePreview = () => {
    setIsPreviewOpen(false);
    // Keep preview data in case user wants to reopen
  };

  if (!isOpen) return null;

  return (
    <>
      {/* Modal Container */}
      <div
        data-tour="report-modal"
        role="dialog"
        aria-label="Painel de relatório"
        className="fixed top-[145px] w-[400px] bg-white rounded-md shadow-xl z-panel flex flex-col box-border max-h-2/3 overflow-y-auto transition-[left] duration-300 ease-in-out left-4"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="p-4 border-b border-[#e0e0e0]">
          <h2 className="text-lg font-semibold text-dark-blue">Relatórios</h2>
        </div>
        <div className="flex-grow p-4 overflow-y-auto">
          <Report
            onPreviewReady={handlePreviewReady}
            selectedDrawingId={selectedDrawingId}
            selectedCityGeometry={selectedCityGeometry}
            selectedCityName={selectedCityName}
            systemMode={systemMode}
            onSelectAreaMarking={onSelectAreaMarking}
            onSelectCityMarking={onSelectCityMarking}
            onDeselectMarking={onDeselectMarking}
          />
        </div>
      </div>

      {/* Report Preview Modal */}
      <ReportPreviewModal
        isOpen={isPreviewOpen}
        reportData={previewData}
        onClose={handleClosePreview}
      />
    </>
  );
}

export default ReportModal;
